import { AccountType } from '@app/enums/account-type.enum';

export const flinkCoUserAccountTypes: AccountType[] = [
	AccountType.FlinkCompanyContributor,
	AccountType.FlinkCompanyLimited,
	AccountType.FlinkCompanyMaster,
];
